module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-dropdown', {
    staticClass: "dropdown-tree",
    attrs: {
      "trigger": "click",
      "menu-align": "start"
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick($event)
      }
    }
  }, [_c('i-input', {
    staticClass: "title",
    class: {
      'title-active': _vm.isDropdownShow
    },
    attrs: {
      "size": _vm.size,
      "placeholder": _vm.placeholder,
      "readonly": true,
      "icon": _vm.iconClass
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  }), _vm._v(" "), _c('i-dropdown-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDropdownShow),
      expression: "isDropdownShow"
    }],
    ref: "panel",
    staticClass: "panel",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-45bfa90d!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/dropdown-tree/src/dropdown-tree.vue
// module id = 646
// module chunks = 0